const getters = {
  permission_routers: state => state.user.routers,
  addRouters: state => state.user.addRouters
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js